module.exports = __webpack_public_path__ + "img/empty-search-2-dark.7af40542.svg";